export default Object.freeze({
  NoSet: 0,
  CareCenter: 246,
  PrivateSchools: 248,
  PublicSchools: 249,
  HeadStart: 250,
  Home: 251,
  Institutions: 349,
});
